import React, { useState, useContext } from "react";
import "../styles/SignupPage.css";
import { useNavigate, Link } from "react-router-dom";
import { AuthContext } from "../components/AuthContext";
import { saveUser } from "../config/firebaseService";
import { FiMail, FiLock, FiUser, FiEye, FiEyeOff } from "react-icons/fi";
import { FcGoogle } from "react-icons/fc";

function SignupPage(){
  //state variables to store user input
  const[first_name, setFirst_name] = useState("");
  const[last_name, setLast_name] = useState("");
  const[email, setEmail] = useState("");
  const[password, setPassword] = useState("");
  const[message, setMessage] = useState("");
  const[showPassword, setShowPassword] = useState(false);

  const { signup, signInWithGoogle } = useContext(AuthContext);
  const navigate = useNavigate();

  //function to handle form submission
  const handleSignup = async (e) => {
    e.preventDefault();

    console.log("Signup-Daten:", { first_name, last_name, email, password });

    const result = await signup(first_name, last_name, email, password);
    if (result.success) {
      await saveUser(result.user_id, `${first_name} ${last_name}`, email);
      setMessage('Account created');
      navigate('/');
    } else {
      setMessage(result.message || 'Signup failed');
    }
  };

  const handleGoogleSignUp = async () => {
    setMessage("");
    const result = await signInWithGoogle();
    if (result.success && result.user_id && result.email) {
      await saveUser(result.user_id, result.name || result.email, result.email);
      navigate('/');
    } else {
      setMessage(result.message || 'Google sign-up failed');
    }
  };

  return (
    <main className="signup-container">
      <section className="signup-left">
        <p className="join-for-free">Join for free</p>
        <h1 className="signup-slogan">
          Create an account on <span className="highlight">clip.board</span>
        </h1>
      </section>

      <section className="signup-right">
        <form className="signup-form" onSubmit={handleSignup} aria-label="Signup form">
          <section className="name-fields">
            <p>
              <input
                id="firstName"
                type="text"
                placeholder="First Name"
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
                required
                autoComplete="given-name"
              />
            </p>
            <p>
              <input
                id="lastName"
                type="text"
                placeholder="Last Name"
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
                required
                autoComplete="family-name"
              />
            </p>
          </section>

          <p className="form-row">
            <label className="input-group">
              <FiMail className="icon" aria-hidden="true" />
              <input
                id="signupEmail"
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </label>
          </p>

          <p className="form-row">
            <label className="input-group">
              <FiLock className="icon" aria-hidden="true" />
              <input
                id="signupPassword"
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
            </label>
            <button
              type="button"
              className="toggle-visibility"
              aria-label={showPassword ? "Hide password" : "Show password"}
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? <FiEyeOff /> : <FiEye />}
            </button>
          </p>

          <button type="submit" className="signup-button">Create Account</button>
          <p className="or-divider" aria-hidden="true"><em>or</em></p>
          <button type="button" className="google-button" onClick={handleGoogleSignUp}>
            <FcGoogle aria-hidden="true" />
            Continue with Google
          </button>
        </form>

        {message && <p className="signup-message" role="alert">{message}</p>}

        <p>
          Already have an account? <Link to="/login" className="login-link">Log in</Link>
        </p>
      </section>
    </main>
  );
}
export default SignupPage;
